export default "__VITE_PUBLIC_ASSET__f64f3085__"